import baseRequest  from '../baseRequest';
import AppConfig    from '../../app/config/AppConfig';

/* actions */
import * as Actions from '../../redux/actions';
import {addPopup} from "../../redux/actions";
import * as popups from "../../constants/popup-types";


class SetDefaultTokenRequest extends baseRequest{

    constructor() {
        super();
        this.dispatch = null;
        this.response = null;
        this.name     = 'Set Default Token Request';
        this.Config   = new AppConfig();
    }

    execute(dispatch, payload) {
        this.dispatch = dispatch;
        this.call(this.Config.api.requests.setDefaultToken, payload);
    }

    // custom on failure
    onFailure(response, methodName = ''){
        this.dispatch(addPopup({
            type:popups.GENERAL_MESSAGE,
            text: response.err.content,
            popup_id: Math.round(Math.random() * 1000000),
        }));
    }

    //Parse successful response
    onSuccess() {
        this.updateState();
    }

    //Dispatch actions to update redux state
    updateState() {
        //if the update succeeded, fetch the updated data
        this.dispatch(Actions.getUserData());
    }

}


export default SetDefaultTokenRequest;